import { TextField, InputAdornment } from '@mui/material';
import React,{ useState } from 'react';

export type ValueData = {
    stringValue: string;
    numericValue: number | null;
    isValid: boolean;
}

export interface ValueInputProps {
    currencySymbol: string;
    label: string;
    decimalPlaces: number;
    allowNegative: boolean;
    className: string
    onValueChange: (value: ValueData) => void;
};


const ValueInput: React.FC<ValueInputProps> = ({ currencySymbol, label, decimalPlaces, allowNegative, className, onValueChange }) => {

    const [value, setValue] = useState('');
    const [error, setError] = useState('');
    const [NANerror, setNANError] = useState<boolean>(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        const decimalPattern = allowNegative
            ? `^-?\\d*\\.?\\d{0,${decimalPlaces}}$`
            : `^\\d*\\.?\\d{0,${decimalPlaces}}$`;

        const regex = new RegExp(decimalPattern);

        if (inputValue === '' || regex.test(inputValue)) {

            const newValue = inputValue;
            setValue(inputValue);

            if (inputValue !== '') {
                const number = parseFloat(inputValue);
                if (isNaN(number)) {
                    setError('Please enter a valid number');
                    setNANError(true);
                } else {
                    setError('');
                    setNANError(false);
                }
            } else {
                setError('');
                setNANError(false);
            }

            if (onValueChange) {
                const numericValue = newValue !== '' ? parseFloat(newValue) : null;
                if (numericValue) {
                    if (isNaN(numericValue)) { setNANError(true) };
                    onValueChange({
                        stringValue: newValue,
                        numericValue: numericValue,
                        isValid: !NANerror
                    });
                }
                else {
                    onValueChange({
                        stringValue: '',
                        numericValue: 0,
                        isValid: false
                    });
                }

            }
        };
    };
        return (
            <TextField
                label={label}
                value={value}
                onChange={handleChange}
                error={!!error}
                helperText={error}
                variant="outlined"
                fullWidth
                className={className}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            {currencySymbol}
                        </InputAdornment>
                    ),
                    inputProps: {
                        pattern: allowNegative ? "-?[0-9]*\.?[0-9]*" : "[0-9]*\.?[0-9]*",
                        inputMode: "decimal",
                        min: allowNegative ? undefined : "0"
                    }
                }}
            />
        );
};

export default ValueInput;